<template>
  <input
    ref="input"
    :value="displayValue"
    class="ag-input-field-input ag-text-field-input"
    style="width: 100%;height: 35px; text-align: right;"
    @input="onInput"
    @blur="onBlur"
  />
</template>

<script>
export default {
  data () {
    return {
      rawValue: '0', // stores unformatted number (e.g., "1234.56")
      displayValue: '0' // stores formatted number
    }
  },
  mounted () {
    // Initialize with existing value
    const initial = this.params.value || 0
    this.rawValue = initial.toString()
    this.updateDisplayValue()

    this.$nextTick(() => {
      this.$refs.input.focus()
      this.$refs.input.select()
    })
  },
  methods: {
    // Format number using the app's $numberFormat method
    formatWithNumberFormat (value) {
      if (!value || value === '') return '0'

      // Remove any existing formatting first
      const cleanValue = value.toString().replace(/[^0-9.-]/g, '')

      // Parse as float
      const num = parseFloat(cleanValue)
      if (isNaN(num)) return '0'

      // Use the passed numberFormat method
      if (this.params.numberFormat) {
        return this.params.numberFormat(num)
      }

      // Fallback
      return num.toLocaleString()
    },

    // Update the display value based on raw value
    updateDisplayValue () {
      this.displayValue = this.formatWithNumberFormat(this.rawValue)
    },

    onInput (e) {
      // Get cursor position before making changes
      const input = e.target
      const cursorPosition = input.selectionStart
      const oldLength = input.value.length

      // Get the raw typed value (remove any existing formatting)
      let rawTyped = e.target.value.replace(/[^0-9.-]/g, '')

      // Allow only numbers, decimal point, and minus sign
      rawTyped = rawTyped.replace(/[^0-9.-]/g, '')

      // Handle multiple decimal points - keep only the first
      const parts = rawTyped.split('.')
      if (parts.length > 2) {
        rawTyped = parts[0] + '.' + parts.slice(1).join('')
      }

      // Handle multiple minus signs - keep only the first
      if (rawTyped.indexOf('-') !== rawTyped.lastIndexOf('-')) {
        const firstMinus = rawTyped.indexOf('-')
        rawTyped = rawTyped.charAt(firstMinus) + rawTyped.slice(firstMinus + 1).replace(/-/g, '')
      }

      // Update raw value (what will be saved)
      this.rawValue = rawTyped === '' ? '0' : rawTyped

      // Update display with formatted value
      this.updateDisplayValue()

      // Set the input field to show formatted value
      input.value = this.displayValue

      // Try to restore cursor position intelligently
      this.$nextTick(() => {
        const newLength = input.value.length
        const addedChars = newLength - oldLength

        // Adjust cursor position based on added formatting characters
        let newPosition = cursorPosition + (addedChars > 0 ? addedChars : 0)
        newPosition = Math.min(newPosition, newLength)

        input.setSelectionRange(newPosition, newPosition)
      })
    },

    onBlur () {
      // Final validation
      let finalValue = this.rawValue
      if (finalValue === '' || finalValue === '.' || finalValue === '-') {
        finalValue = '0'
      } else {
        const num = parseFloat(finalValue)
        finalValue = isNaN(num) ? '0' : num.toString()
      }

      this.rawValue = finalValue
      this.updateDisplayValue()

      // Update input with formatted value
      this.$refs.input.value = this.displayValue

      // Stop editing
      this.params.stopEditing()
    },

    getValue () {
      // Return the raw number value to the grid
      const value = parseFloat(this.rawValue)
      return isNaN(value) ? 0 : value
    }
  }
}
</script>
